import { render, staticRenderFns } from "./DropdownPluginWriter.vue?vue&type=template&id=272319f2&scoped=true&"
import script from "./DropdownPluginWriter.vue?vue&type=script&lang=js&"
export * from "./DropdownPluginWriter.vue?vue&type=script&lang=js&"
import style0 from "./DropdownPluginWriter.vue?vue&type=style&index=0&id=272319f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272319f2",
  null
  
)

export default component.exports